import React from "react"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select"

interface VoteRatingSelectProps {
    value?: string
    onValueChange: (value: string) => void
}

export const VoteRatingSelect: React.FC<VoteRatingSelectProps> = ({
    value = "all",
    onValueChange,
}) => {
    return (
        <Select onValueChange={onValueChange} defaultValue={value}>
            <SelectTrigger className="w-[180px] rounded-full">
                <SelectValue placeholder="All Vote Ratings" />
            </SelectTrigger>
            <SelectContent className="z-[102]">
                <SelectItem value="all">All Vote Ratings</SelectItem>
                <SelectItem value="5">5 Stars</SelectItem>
                <SelectItem value="4">4+ Stars</SelectItem>
                <SelectItem value="3">3+ Stars</SelectItem>
                <SelectItem value="2">2+ Stars</SelectItem>
                <SelectItem value="1">1+ Stars</SelectItem>
            </SelectContent>
        </Select>
    )
}
